export default "__VITE_ASSET__746de15a__"